import { useParams } from "react-router-dom";
import Layout from "../layouts/Layout";
import Breadcrumb from "../components/Breadcrumb";
import ProjectDetailsSection from "../components/Project/ProjectDetailsSection";
import { projectsData } from "../data/projectsData";

const ProjectDetail = () => {
  const { slug } = useParams();
  const project = projectsData.find((p) => p.slug === slug);

  return (
    <Layout>
      <Breadcrumb
        title={project.title}
        parent={{ name: "Trang chủ", path: "/" }}
        parent2={{ name: "Dự án", path: "/du-an" }}
      />
      <ProjectDetailsSection project={project} />
    </Layout>
  );
};

export default ProjectDetail;
